module.exports = __webpack_public_path__ + "static/demo-30184fa83cb4ab8fb7809cf95cc8aec3.png";